import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";

const initialState = {
    contacts: [],
    loading: false,
    saving: false
};

export default function companyContact(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_COMPANY_CONTACT:
            newState.loading = true;
            break;

        case actions.SAVING_COMPANY_CONTACT:
            newState.saving = true;
            break

        case actions.RECEIVED_COMPANY_CONTACTS:
            newState.loading = false;
            newState.contacts = utils.mapById(action.payload)
            break

        case actions.SAVED_COMPANY_CONTACT:
            let found = false;

            for (let i = 0; i < newState.contacts.length; i++) {
                if(newState.contacts[i].id === action.payload.id){
                    found = true;

                    newState.contacts[i] = action.payload;
                }
            }

            if(!found) {
                newState.contacts.add(
                    action.payload
                );
            }

            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_COMPANY_CONTACTS:
            newState.loading = false;
            newState.saving = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/companyContact.js